// Repli des comparaisons, tuile par tuile (Olivier, bêta-testeur du Grand Besançon, réunion des
// fondateurs du 14/10 ; Cyrille : « tuile par tuile, chaque tuile doit avoir son petit bouton »).
// Fichier à part, comme `MasquerTuile.tsx` : les commandes, rendues par `KpiCard` et `ChartCard`.
// Les règles (qui a des comparaisons, ce qu'il en reste) vivent dans `repliComparaisons.ts`, la
// mémoire au compte dans `prefs.ts`.
import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react'
import './repli.css'

/** Les places du coin haut droit d'une tuile, depuis le bord : 1 l'épingle, 2 le partage,
    3 « masquer », 4 la suivante. Le bouton de repli prend la première place libre À GAUCHE de la
    commande la plus à gauche que la tuile rend ; le titre la réserve (obs.css, `--coin-*`). */
export type Coin = 1 | 2 | 3 | 4

/** Le bouton d'en-tête : « Masquer les comparaisons » / « Afficher les comparaisons », nommé par
    la tuile (une page en porte des dizaines), `aria-pressed` vrai quand la tuile est repliée.
    Discret au repos comme ses voisins, toujours visible une fois enfoncé (comme l'épingle active)
    et sur un écran tactile. Cible de 24 px (WCAG 2.5.8). */
export function BoutonRepli({ nom, replie, coin, onBasculer }:
                            { nom: string; replie: boolean; coin: Coin; onBasculer: () => void }) {
  return (
    <button type="button" className={`obs2-replier obs2-coin-${coin}`}
      aria-pressed={replie}
      aria-label={`${replie ? 'Afficher' : 'Masquer'} les comparaisons de « ${nom} »`}
      title={replie ? 'Afficher les comparaisons' : 'Masquer les comparaisons (seul ce territoire)'}
      onClick={e => { e.preventDefault(); e.stopPropagation(); onBasculer() }}>
      {replie ? <ChevronsUpDown size={13} aria-hidden="true" />
              : <ChevronsDownUp size={13} aria-hidden="true" />}
    </button>
  )
}

/** La ligne discrète d'une tuile repliée : elle dit que les comparaisons sont masquées — rien
    n'a disparu en silence — et porte de quoi les réafficher, là où elles étaient. */
export function AvisRepli({ onAfficher }: { onAfficher: () => void }) {
  return (
    <p className="obs2-repli-avis">
      <span>Comparaisons masquées</span>
      <button type="button" className="obs2-repli-afficher"
        onClick={e => { e.preventDefault(); e.stopPropagation(); onAfficher() }}>
        Afficher les comparaisons
      </button>
    </p>
  )
}
